import {
  createHeadersMiddleware,
  type UntypedApiClient,
} from '@asset-metrix/openapi-client-core';
import {
  type ApiClient,
  createApiClient,
} from '@asset-metrix/portal-api-client-js';
import { v4 as uuid } from 'uuid';

import Session from './Session';

// Extended client type that includes an untyped client for auth endpoints not in schema
export type PortalApiClient = ApiClient & {
  untyped: UntypedApiClient;
};

export const getTracingHeaders = (session?: Session) => ({
  'X-Request-Id': uuid(),
  'X-Session-Id': session?.getDecodedAuthToken()?.jti ?? 'no-session-id',
});

export const getRequestHeaders = (session: Session) => ({
  ...(session.getAuthToken()
    ? { authorization: `Bearer ${session.getAuthToken()}` }
    : {}),
  ...getTracingHeaders(session),
});

export const createPortalApiClient = ({
  apiId,
  baseUrl,
  session,
}: {
  apiId: string;
  baseUrl: string;
  session: Session;
}): PortalApiClient => {
  const requestHeadersMiddleware = createHeadersMiddleware({
    getHeaders: () => ({
      'x-api-id': apiId,
      ...getRequestHeaders(session),
    }),
    preserveExisting: true,
  });

  const { typed, untyped } = createApiClient(
    {
      baseUrl,
    },
    [requestHeadersMiddleware]
  );

  console.debug('Portal-API client initialized with baseUrl %s', baseUrl);

  return {
    ...typed,
    untyped,
  };
};
